import React from 'react';
import Grid from '../../common/Grid/Grid';
import MyFeedbackResultCardItem from './MyFeedbackResultCardItem';

/**
 * MyFeedbackResultsGrid - Virtualized grid for displaying feedback result cards
 * Uses the shared Grid component with react-window for performance
 */
const MyFeedbackResultsGrid = ({
  assignments,
  isLoading,
  isLoadingMore,
  pageInfo,
  handleItemClick,
  handleGridScroll,
  showLoadingSpinner,
  shouldHideContent,
  loadMoreData,
  gridRef,
  onViewReport,
  hasFiltersApplied,
  captureScrollState,
}) => {
  const renderItem = ({ item }) => {
    // Capture scroll state for this specific item
    const scrollState = captureScrollState ? captureScrollState(item) : null;

    return (
      <MyFeedbackResultCardItem
        assignment={item}
        onViewReport={(assignmentId) => onViewReport(assignmentId, scrollState)}
      />
    );
  };

  // Dynamic empty state description based on filters
  const emptyStateDescription = hasFiltersApplied
    ? "No assignments match your search criteria. Try adjusting your filters."
    : "You don't have any feedback assignments yet.";

  return (
    <Grid
      items={assignments}
      isLoading={isLoading}
      isLoadingMore={isLoadingMore}
      pageInfo={pageInfo}
      renderItem={renderItem}
      handleItemClick={handleItemClick}
      handleGridScroll={handleGridScroll}
      showLoadingSpinner={showLoadingSpinner}
      shouldHideContent={shouldHideContent}
      loadMoreData={loadMoreData}
      gridRef={gridRef}
      emptyStateTitle="No Feedback Assignments Found"
      emptyStateDescription={emptyStateDescription}
      endOfListMessage="You've reached the end of the list"
      rowHeight={620}
    />
  );
};

export default MyFeedbackResultsGrid;
